import React from 'react';
import Style from './style.sass';

const ColorPicker = ({value, onChange}) => {
  return (
    <div className={Style.Triangle__colorPicker}>
      <label>色</label>
      <input className={Style.Triangle__colorName} type='text' value={value} onChange={onChange}/>
      <input className={Style.Triangle__colors} type='color' value={value} onChange={onChange}/>
    </div>
  )
}
export default ColorPicker;